import { BrowserRouter, Switch, Route, HashRouter } from 'react-router-dom';

import React, { Component } from 'react';
import NotFound from 'ASSESSMENT/CommonResources/NotFound/NotFound';
import ResultList from 'ASSESSMENT/Components/ResultList/ResultList';
import GradeCardList from 'ASSESSMENT/Components/GradeCardList/GradeCardList';
import StudentResultList from 'ASSESSMENT/Components/StudentResultList/StudentResultList';

let apiPath = 'api/assessment/publicLink.php';

export class Routes extends Component {
    render() {
        return (
            <>
                <HashRouter>
                    <Switch>
                        <Route exact path="/" component={NotFound} />
                        <Route exact path="/:instituteUrl" component={ResultList} />
                        <Route path="/:instituteUrl/gradecard" component={GradeCardList} />
                        <Route path="/:instituteUrl/student-result" component={StudentResultList} />
                        <Route path="*" component={NotFound} />
                    </Switch>
                </HashRouter>
            </>
        )
    }
}

export default Routes;
